import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Header from "./components/header";
import AddExpense from "./pages/add-expense";
import Home from "./pages/home/index";


const App = () => {
  return (
    
      <Router>
      <Header />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/add-expense" component={AddExpense} />
      </Switch>
      {/* <Footer /> */}
      </Router>

  );
};

export default App;
